(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        AlertServiceProvider.showAsToast(false);
    }
})();
